import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import { NavLink, useNavigate } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

/**
 * This scene handles removing any client-side auth data (local storage, axios interceptors, logged in state, etc),
 * and closing any preloaders that may have been left open, when an API call results in an HTTP 401.
 * This prevents the LoginScene from needing to handle this behavior, and prevents the login scene route from needing
 * to be accessible to a logged-in user
 *
 * @constructor
 */
const InactiveScene = () => {
    const { authStore, preloaderStore } = useContext(StoresContext)
    const navigate = useNavigate()

    useEffect(() => {
        analyticsSendPage('inactive')
        authStore.clearLoginData()
        navigate(Navigation.login.inactive())
        preloaderStore.openMainPreloader(false)
        preloaderStore.openTransparentPreloader(false)
    }, [])

    return (
        <>
            {/* This should only appear if an error happens with the useEffect  */}
            <NavLink to={Navigation.login.inactive()}>Go To Login Page</NavLink>
        </>
    )
}

export default InactiveScene
